/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EpexPriceResponse } from '../../models/epex-price-response';

export interface ParseEpexPriceSeries$Params {
  location_id: string;
  date?: string;
  
    /**
     * The EPEX market-results table as copied from the browser
     */
    body?: string
}

export function parseEpexPriceSeries(http: HttpClient, rootUrl: string, params: ParseEpexPriceSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<EpexPriceResponse>> {
  const rb = new RequestBuilder(rootUrl, parseEpexPriceSeries.PATH, 'post');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('date', params.date, {});
    rb.body(params.body, 'text/plain');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EpexPriceResponse>;
    })
  );
}

parseEpexPriceSeries.PATH = '/locations/{location_id}/epex-price-series';
